module.exports = __webpack_public_path__ + "static/img/fz_xe_tz.f436c7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_xe_tz.png
// module id = JhtD
// module chunks = 0